<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v"></a>
<h1 class="toc-title">Contents</h1>
<h2 class="tocf"><a href="#/xhtml/Acknowledgements">Acknowledgements</a></h2>
<h2 class="tocfb"><a href="#/xhtml/Introduction">Introduction</a></h2>
<h2 class="tocc"><a href="#/xhtml/Chapter01"><span class="tsp">Chapter 1</span> The Origins of a Great Family</a></h2>
<h2 class="tocc"><a href="#/xhtml/Chapter02"><span class="tsp">Chapter 2</span> The Path to Power</a></h2>
<h2 class="tocc"><span href="#/xhtml/Chapter03" title="Link target outside of Sample"><span class="tsp">Chapter 3</span> Heretics and Martyrs</span></h2>
<h2 class="tocc"><span href="#/xhtml/Chapter04" title="Link target outside of Sample"><span class="tsp">Chapter 4</span> A New Regime</span></h2>
<h2 class="tocc"><span href="#/xhtml/Chapter05" title="Link target outside of Sample"><span class="tsp">Chapter 5</span> The Hunt for a King</span></h2>
<h2 class="tocc"><span href="#/xhtml/Chapter06" title="Link target outside of Sample"><span class="tsp">Chapter 6</span> The Secretary’s Circle</span></h2>
<h2 class="tocc"><span href="#/xhtml/Chapter07" title="Link target outside of Sample"><span class="tsp">Chapter 7</span> Patronage, Influence and Intrigue</span></h2>
<h2 class="tocc"><span href="#/xhtml/Chapter08" title="Link target outside of Sample"><span class="tsp">Chapter 8</span> A Family Man</span></h2>
<h2 class="tocc"><span href="#/xhtml/Chapter09" title="Link target outside of Sample"><span class="tsp">Chapter 9</span> Treachery and Victory</span></h2>
<h2 class="tocc"><span href="#/xhtml/Chapter10" title="Link target outside of Sample"><span class="tsp">Chapter 10</span> The Final Decade</span></h2>
<h2 class="tocc"><span href="#/xhtml/Chapter11" title="Link target outside of Sample"><span class="tsp">Chapter 11</span> The Cecil Succession</span></h2>
<h2 class="tocc"><span href="#/xhtml/Chapter12" title="Link target outside of Sample"><span class="tsp">Chapter 12</span> Crisis and Rebellion</span></h2>
<h2 class="tocc"><span href="#/xhtml/Chapter13" title="Link target outside of Sample"><span class="tsp">Chapter 13</span> The Queen is Dead, Long Live the King</span></h2>
<h2 class="tocc"><span href="#/xhtml/Chapter14" title="Link target outside of Sample"><span class="tsp">Chapter 14</span> Gunpowder</span></h2>
<h2 class="tocc"><span href="#/xhtml/Epilogue" title="Link target outside of Sample"><span class="tsp">Epilogue</span> The Legacy of a Great Family</span></h2>
<h2 class="tocbt"><span href="#/xhtml/Author" title="Link target outside of Sample">Author’s Final Note</span></h2>
<h2 class="tocb"><span href="#/xhtml/Notes" title="Link target outside of Sample">Endnotes</span></h2>
<h2 class="tocb"><span href="#/xhtml/Bibliography" title="Link target outside of Sample">Bibliography</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?45b35118